import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdf = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.1665 2H14.1665L20.1665 8V20C20.1665 21.1 19.2665 22 18.1665 22H6.1565C5.0565 22 4.1665 21.1 4.1665 20L4.1765 4C4.1765 2.9 5.0665 2 6.1665 2ZM6.1665 4V20H18.1665V9H13.1665V4H6.1665Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.1665 15H9.1665C9.7165 15 10.1665 14.55 10.1665 14V13C10.1665 12.45 9.7165 12 9.1665 12H7.1665V17H8.1665V15ZM14.1665 16V13C14.1665 12.45 13.7165 12 13.1665 12H11.1665V17H13.1665C13.7165 17 14.1665 16.55 14.1665 16ZM12.1665 13H13.1665V16H12.1665V13ZM17.1665 15H16.1665V17H15.1665V12H17.1665V13H16.1665V14H17.1665V15ZM9.1665 13H8.1665V14H9.1665V13Z",
			fill: "#2771bb"
		})
	]
});
const ForwardRef = forwardRef(SvgPdf);
export default ForwardRef;
